import type { ProfileIconBackgroundId, ProfileIconId } from '@trove/contracts';

export const PROFILE_ICON_OPTIONS: Array<{
  id: ProfileIconId;
  label: string;
  emoji: string;
}> = [
  { id: 'user', label: 'Person', emoji: '👤' },
  { id: 'leaf', label: 'Leaf', emoji: '🍃' },
  { id: 'mountain', label: 'Mountain', emoji: '⛰️' },
  { id: 'sun', label: 'Sun', emoji: '☀️' },
  { id: 'moon', label: 'Moon', emoji: '🌙' },
  { id: 'sparkles', label: 'Sparkles', emoji: '✨' },
  { id: 'coffee', label: 'Coffee', emoji: '☕' },
  { id: 'book', label: 'Book', emoji: '📚' },
];

export const PROFILE_ICON_BACKGROUND_OPTIONS: Array<{
  id: ProfileIconBackgroundId;
  label: string;
  hex: string;
}> = [
  { id: 'slate', label: 'Slate', hex: '#e3edf2' },
  { id: 'jade', label: 'Jade', hex: '#d8f4e5' },
  { id: 'sky', label: 'Sky', hex: '#dcefff' },
  { id: 'violet', label: 'Violet', hex: '#eae4fb' },
  { id: 'amber', label: 'Amber', hex: '#fff0cc' },
  { id: 'rose', label: 'Rose', hex: '#ffe1e5' },
  { id: 'forest', label: 'Forest', hex: '#dceedd' },
  { id: 'orange', label: 'Orange', hex: '#ffe5d2' },
];

export function profileIconEmoji(id: ProfileIconId | undefined) {
  return PROFILE_ICON_OPTIONS.find((entry) => entry.id === (id ?? 'user'))?.emoji ?? '👤';
}
